const routePath = require.context('@/routes/setting', true, /\.js$/)
const routes = routePath.keys().filter(path => path !== './index.js').map((path) => {
  const route = routePath(path)
  return route.default || route
})

export default routes
